import { render, staticRenderFns } from "./choose-integration-dialog.vue?vue&type=template&id=54806247&scoped=true&"
import script from "./choose-integration-dialog.vue?vue&type=script&lang=ts&"
export * from "./choose-integration-dialog.vue?vue&type=script&lang=ts&"
import style0 from "./choose-integration-dialog.vue?vue&type=style&index=0&id=54806247&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54806247",
  null
  
)

export default component.exports